<script>
const sidebarMenu = [
  // { path: '/', icon: 'fa fa-th', title: 'Home' },

  //Highlight
  { path: '/dashboard/highlight', icon: 'far fa-th-large', title: 'Highlights',
    children : [
      { path: '/dashboard/highlight/label-maker', title: 'Label Maker' },
      { path: '/dashboard/highlight/oil-maker', title: 'Oil Maker' },
      { path: '/dashboard/highlight/customer', title: 'Customer' },
    ]
  },

  //Activities
  { path: '/dashboard/customer-activities', icon: 'far fa-chart-bar', title: 'Customer Activities' },

  //Consumer Insights
  // { path: '/dashboard/consumer-insights', icon: 'far fa-users', title: 'Consumer Insight' },

  //Reports
  { path: '/dashboard/reports', icon: 'far fa-file-alt', title: 'Reports',
    children: [
      { path: '/dashboard/reports/customer', title: 'Report Customer' },
      { path: '/dashboard/reports/label-maker', title: 'Report Label Maker' },
      { path: '/dashboard/reports/oil-maker', title: 'Report Oil Maker' },
      { path: '/dashboard/reports/suspect', title: 'Report Suspect' },
      { path: '/dashboard/reports/qrcode', title: 'QR Code' },
      { path: '/dashboard/reports/summary-report', title: 'Summary Report' },
      { path: '/dashboard/reports/not-found-report', title: 'Not Found Report' }
    ]
  },

  //Summary Report
  // { path: '/dashboard/summary-report', icon: 'far fa-file', title: 'Summary Report' },

  //Settings
  { path: '/dashboard/settings', icon: 'far fa-wrench', title: 'Settings',
    children: [
      { path: '/dashboard/settings/log-history-activity', title: 'Log History Activity' },
      { path: '/dashboard/settings/user-management', title: 'User Management',
        children : [
          { path: '/dashboard/settings/user-management/dashboard-user', title: 'Dashboard User' },
          { path: '/dashboard/settings/user-management/oil-maker-app', title: 'Oil Maker App' },
          { path: '/dashboard/settings/user-management/penindakan-app', title: 'Penindakan App' },
        ]
      },
    ]
  },

  //CSO
  // { path: '/cso', icon: 'fas fa-table', title: 'CSO',
  //   children: [
  //     { path: '/cso/exit-permit', title: 'Gatepass' },
  //     { path: '/cso/customer-quotation', title: 'Quotation' },
  //     { path: '/cso/insurance-policy', title: 'Insurance Policy' },
  //     { path: '/cso/master-data', title: 'Master Data',
  //       children: [
  //         { path: '/cso/master-data/color', title: 'Warna Mobil' },
  //         { path: '/cso/master-data/brand-&-type', title: 'Merk Dan Tipe Mobil' },
  //         { path: '/cso/master-data/customer', title: 'Pelanggan' },
  //         { path: '/cso/master-data/customer-car', title: 'Mobil Pelanggan' },
  //         { path: '/cso/master-data/laborer', title: 'Pekerja' },
  //         { path: '/cso/master-data/supplier', title: 'Supplier' },
  //       ]
  //     },
  //   ]
  // },
]

export default sidebarMenu;
</script>
